import AdtPlugin from "./adt/AdtPlugin";
import CrossRecordPlugin from "./cross-record/CrossRecordPlugin";
import HemoPlugin from "./hemo/HemoPlugin";
import EcmoEmrPlugin from "./ecmoemr/EcmoEmrPlugin";
import CrossAppPlugin from "./cross-app/CrossAppPlugin";

export default (key, options) => {
    switch (key) {
        case "adt":
            return new AdtPlugin(options);
        case "cross-record":
            return new CrossRecordPlugin(options);
        case "hemo":
            return new HemoPlugin(options);
        case "ecmoemr":
            return new EcmoEmrPlugin(options);
        case "cross-app":
            return new CrossAppPlugin(options);
        default:
            throw Error(`Cannot find mapping plugin with key ${key}.`);
    }
};



// WEBPACK FOOTER //
// ./app/lib/mapping/sources/resolver.js